var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AccountSettingsService } from '../account-settings.service';
import { combineLatest } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Ng1ModalService } from '../../shared/ng1/ng1-modal.service';
import { AmplitudeService } from '../../shared/services/amplitude.service';
import { markFormAsTouched } from '../../lead-generation/shared/reactive-forms/forEachElementInForm';
import { MatDialog } from '@angular/material/dialog';
import { ChangePlanConfirmationComponent } from './change-plan-confirmation/change-plan-confirmation.component';
import { Ng1LiveChatService } from '../../shared/ng1/ng1-live-chat.service';
import { ChangePlanSummaryDialogComponent } from './change-plan-summary/change-plan-summary-dialog.component';
var ChoosePlanComponent = /** @class */ (function () {
    function ChoosePlanComponent(fb, accountSettingsService, amplitudeService, ng1ModalService, matDialog, liveChatService) {
        this.fb = fb;
        this.accountSettingsService = accountSettingsService;
        this.amplitudeService = amplitudeService;
        this.ng1ModalService = ng1ModalService;
        this.matDialog = matDialog;
        this.liveChatService = liveChatService;
        this.loading = false;
        this.initialNumberOfUsers = 0;
    }
    ChoosePlanComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.accountSettingsService.getSubscription().subscribe(function (subscription) {
            _this.currentSubscription = subscription;
            if (_this.alreadyHasPlan()) {
                _this.initialNumberOfUsers = _this.currentSubscription.licenses[0].quantity;
                _this.panelForm.controls.numberOfUsers.setValue(_this.initialNumberOfUsers);
            }
            _this.updateNumberOfUsers();
        });
        this.panelForm = this.fb.group({
            billingPeriod: this.fb.control('P1M'),
            numberOfUsers: this.fb.control('', [Validators.required, Validators.min(1)])
        });
        this.plans$ = this.subscribeToVisiblePlansChanges();
    };
    ChoosePlanComponent.prototype.subscribePlan = function (plan) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.canSubscribePlan(plan)) {
                            return [2 /*return*/];
                        }
                        if (this.panelForm.invalid) {
                            this.handleInvalidFormSubscription();
                            return [2 /*return*/];
                        }
                        if (plan.isEnterprise) {
                            this.handleEnterprisePlanSubscription();
                            return [2 /*return*/];
                        }
                        if (this.numberOfUsers > plan.usersLimit) {
                            this.handleInvalidFormSubscription();
                            this.isUserLimitReached = true;
                            return [2 /*return*/];
                        }
                        if (this.numberOfUsers < plan.usersMinimum) {
                            this.panelForm.controls.numberOfUsers.setValue(plan.usersMinimum);
                        }
                        return [4 /*yield*/, this.handleValidPlanSubscription(plan, this.currentSubscription.status === 'TRIAL')];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChoosePlanComponent.prototype.canSubscribePlan = function (plan) {
        if (this.loading) {
            return false;
        }
        var modifyCurrentSubscription = this.alreadyHasPlan() &&
            this.currentSubscriptionIsActive() &&
            this.currentSubscription.licenses[0].planId === plan.id;
        if (modifyCurrentSubscription) {
            return this.numberOfUsersChanged();
        }
        return true;
    };
    ChoosePlanComponent.prototype.numberOfUsersChanged = function () {
        var chosenNumberOfUsers = parseInt(this.panelForm.getRawValue().numberOfUsers, 10);
        return chosenNumberOfUsers !== this.initialNumberOfUsers;
    };
    ChoosePlanComponent.prototype.handleValidPlanSubscription = function (plan, isTrial) {
        return __awaiter(this, void 0, void 0, function () {
            var featuresDowngradeAccepted, changeSummaryAccepted;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        this.logAmplitude('About to subscribe plan', { planId: plan.id, isTrial: isTrial });
                        return [4 /*yield*/, this.showDowngradeFeaturesWarningDialog(plan)];
                    case 1:
                        featuresDowngradeAccepted = _a.sent();
                        if (!featuresDowngradeAccepted) {
                            this.logAmplitude('Plan not subscribed after confirmation dialog');
                            this.loading = false;
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.showChangePlanSummaryDialog(plan, isTrial)];
                    case 2:
                        changeSummaryAccepted = _a.sent();
                        if (!changeSummaryAccepted) {
                            this.logAmplitude('Plan not subscribed after summary info');
                            this.loading = false;
                            return [2 /*return*/];
                        }
                        if (this.numberOfUsers < this.users.length) {
                            this.logAmplitude('Cannot subscribe - too many users', { planId: plan.id });
                            this.loading = false;
                            return [2 /*return*/, this.showPlanLimitsUsers(function () { return _this.startSubscriptionPaymentFlow(plan); })];
                        }
                        this.startSubscriptionPaymentFlow(plan);
                        return [2 /*return*/];
                }
            });
        });
    };
    ChoosePlanComponent.prototype.showDowngradeFeaturesWarningDialog = function (plan) {
        return __awaiter(this, void 0, void 0, function () {
            var accountLimits;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.accountSettingsService
                            .getChangeSubscriptionLimits(plan.id)
                            .toPromise()];
                    case 1:
                        accountLimits = _a.sent();
                        return [4 /*yield*/, this.matDialog
                                .open(ChangePlanConfirmationComponent, { data: { accountLimits: accountLimits, plan: this.currentSubscription } })
                                .afterClosed()
                                .toPromise()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ChoosePlanComponent.prototype.showChangePlanSummaryDialog = function (newPlan, isTrial) {
        if (isTrial) {
            // summary info for trial accounts is shown in the Stripe Checkout form
            return Promise.resolve(true);
        }
        var _a = this.panelForm.getRawValue(), usersString = _a.numberOfUsers, billingPeriod = _a.billingPeriod;
        var numberOfUsers = parseInt(usersString, 10);
        var data = { numberOfUsers: numberOfUsers, billingPeriod: billingPeriod, newPlan: newPlan, currentSubscription: this.currentSubscription };
        return this.matDialog
            .open(ChangePlanSummaryDialogComponent, {
            data: data,
            panelClass: ['mobile-full-width-dialog', 'large-width-dialog']
        })
            .afterClosed()
            .toPromise();
    };
    ChoosePlanComponent.prototype.startSubscriptionPaymentFlow = function (plan) {
        this.logAmplitude('Plan will be subscribed', { planId: plan.id });
        this.accountSettingsService.submitSubscription({
            planId: plan.id,
            quantity: this.numberOfUsers
        });
    };
    ChoosePlanComponent.prototype.handleInvalidFormSubscription = function () {
        this.logAmplitude('Cannot subscribe - invalid form', this.panelForm.errors);
        markFormAsTouched(this.panelForm);
    };
    ChoosePlanComponent.prototype.handleEnterprisePlanSubscription = function () {
        this.logAmplitude('About to subscribe enterprise plan');
        this.liveChatService.contactSupport();
    };
    ChoosePlanComponent.prototype.updateNumberOfUsers = function () {
        var _this = this;
        this.accountSettingsService.getAllButAdministrativeUsers().subscribe(function (users) {
            var activeUsers = users.filter(function (s) { return s.state !== 'INACTIVE'; });
            _this.users = activeUsers;
            if (!_this.alreadyHasPlan()) {
                _this.initialNumberOfUsers = activeUsers.length;
                _this.panelForm.controls.numberOfUsers.setValue(_this.initialNumberOfUsers);
            }
        });
    };
    ChoosePlanComponent.prototype.showPlanLimitsUsers = function (callback) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ng1ModalService.lazyModalService.showPlanLimitUsersModal('PLANS.TOO_MANY_ACTIVE_USERS', 'PLANS.TOO_MANY_ACTIVE_USERS_DESCRIPTION', this.users, this.numberOfUsers)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.accountSettingsService.updateUsersLimit(response).toPromise()];
                    case 2:
                        _a.sent();
                        callback();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ChoosePlanComponent.prototype, "numberOfUsers", {
        get: function () {
            return this.panelForm.controls.numberOfUsers.value;
        },
        enumerable: true,
        configurable: true
    });
    ChoosePlanComponent.prototype.subscribeToVisiblePlansChanges = function () {
        var billingPeriodCtrl = this.panelForm.controls.billingPeriod;
        var billingPeriodChanges$ = billingPeriodCtrl.valueChanges.pipe(startWith(billingPeriodCtrl.value));
        var plansChanges$ = this.accountSettingsService.getPlans();
        return combineLatest(plansChanges$, billingPeriodChanges$).pipe(map(function (_a) {
            var plans = _a[0], billingPeriod = _a[1];
            var plansToShow = plans
                .filter(function (plan) { return plan.interval === billingPeriod; })
                .sort(function (a, b) { return a.pricePerUserCents - b.pricePerUserCents; });
            console.log(plansToShow);
            return plansToShow /* EnterprisePlan // hide from Shopify's eyes */.slice();
        }));
    };
    ChoosePlanComponent.prototype.alreadyHasPlan = function () {
        return this.currentSubscription && this.currentSubscription.licenses && this.currentSubscription.licenses.length;
    };
    ChoosePlanComponent.prototype.logAmplitude = function (message, param) {
        if (param === void 0) { param = {}; }
        this.amplitudeService.logEvent("Panel:Account:Plan " + message, __assign({}, this.panelForm.getRawValue(), param));
    };
    ChoosePlanComponent.prototype.currentSubscriptionIsActive = function () {
        if (!this.alreadyHasPlan()) {
            return false;
        }
        var status = this.currentSubscription.status;
        return status === 'ACTIVE' || status === 'TRIAL';
    };
    return ChoosePlanComponent;
}());
export { ChoosePlanComponent };
